import React from 'react'
import { observer } from 'mobx-react-lite'

import { ProjectsDetailTable } from '../../ProjectsDetailTable'

import projectsStore from '../../../../Store'

const Expenses = observer(() => {
  const { toggleSideBar } = projectsStore

  return (
    <ProjectsDetailTable
      params={{
        status: 'PAID',
        category: 'payable',
      }}
      openSidebar={toggleSideBar}
    />
  )
})

export default Expenses
